// extracted by mini-css-extract-plugin
export var container = "externalArticleCard-module--container--DzE9v";
export var imageContainer = "externalArticleCard-module--image-container--KpEyf";
export var textContainer = "externalArticleCard-module--text-container--3uvaB";